<template lang="pug">
section.singleCinemagraph__section
  .info-Modal(v-if="modalShow")
    .h-vertical-align-container
      .modal__close(@click='overlay()')
      .modal__overlay(@click='overlay()')
      .modal__wrapper    
        .modal__object
          .modal__container
            .message__container
              .message.success(v-if='success')
                p Your Flixel was updated.
                a.close(@click='overlay()')
              .message.error(v-if='error')
                p There was an error updating your Flixel.
                a.close(@click='overlay()')
          .deleteCinemagraph__modal(v-if='modalDelete')
            h1 Are you sure you want to delete this cinemagraph?
            p This is a permanent action. No take backs!
            button.btn.btn--red(@click='deleteFlixelInvoke(flixel.hash)') Yes, delete it!
            button.btn.btn--white(@click='overlay()') Cancel

  single-flixel(:flixel='flixel', resize='true')
  .loading__cover(v-if='loading')
  .loading--full(v-if='loading')
  .flixelDetail
    .flixelDetail__item.flixelDetail__item--social
      social-sharing(:flixel='flixel')

    .flixelDetail__item
      .flixelDetail__item--title
        a(:href='flixel.username', v-if='flixel.user_avatar')
          img(:src='flixel.user_avatar')
        a(:href='flixel.username')
          h1 {{ flixel.username }}
      .flixelDetail__item--text(v-if='flixel.caption')
        p {{ flixel.caption }}

      .flixelDetail__item--text
        p.item__date Posted {{ flixel.date_created | date }}

      .flixelDetail__item--text(v-if='isOwner')
        h2 Embed Target URL
        a(:href='flixel.custom_target_link')  {{ flixel.custom_target_link || 'No link' }}

      .flixelDetail__item--text(v-if='flixel.watermark_url && isOwner')
        h2 Custom Watermark
        img.image.preview(:src='flixel.watermark_url', v-if='flixel.watermark_url')

      .flixelDetail__item--text(v-if='isOwner', @click="showEditMenu()")
        a
          button.btn.btn__white Edit
  aside#flixelEdit
    .flixelEdit__container
      form(name='update_flixel', v-on:submit.prevent='')
        .ui-input
          .ui-input--itemTitle
            label Caption
            span {{ 110 - editFlixel.caption.length }}
          .ui-input--itemContent
            textarea(
              v-model='editFlixel.caption',
              maxlength=110,
              placeholder='Tell us about your cinemagraph.')
        
        .ui-input
          .ui-input--itemTitle
            label Privacy
          .ui-input--itemContent
            div
              input(name='privacy',
                type='radio',
                value='1'
                v-model='editFlixel.privacy')
              span Public
            div
              input(name='privacy',
                type='radio',
                value='2'
                v-model='editFlixel.privacy')
              span Shareable
            div
              input(name='privacy',
                type='radio',
                value='3'
                v-model='editFlixel.privacy')
              span Private
          hr
          .ui-input
            .ui-input--itemTitle
              label Show Embed
            .ui-input--itemContent
              div
                input(type='checkbox', 
                  v-model='editFlixel.embedable')
                span Allow others to easily share
          
          hr
          .ui-input
            .ui-input--itemTitle
              label Embed Target URL
            .ui-input--itemContent
              div
                input(
                  type='radio',
                  @click='useDefault()',
                  value='true',
                  v-model='EmbedTargetURLSelected'
                  )
                span(
                  :class='{ active: editFlixel.target === flixel.link }'
                  ) Use Default
              div

                input(
                  type='radio',
                  @click='noLink()',
                  value='false',
                  v-model='EmbedTargetURLSelected'
                  )
                span(
                  :class='{ active: editFlixel.target === "" }'
                  ) No Link
            .ui-input--itemContent
              input(
                type='text',
                :class='{ faded: editFlixel.target === ""}'
                v-model='editFlixel.custom_target_link',
                placeholder='http://www.myurl.com')
          
          hr
          .ui-input
            .ui-input--itemTitle
              label Show Social Sharing
            .ui-input--itemContent
              div
                input(type='checkbox', 
                  v-model='editFlixel.shareable')
                span Allow others to easily share
                            
          hr
        .ui-input
          .ui-input--itemContent
            .btn__group
              a(@click='showDelete()') 
                button.btn.btn--red Delete Cinemagraph
              a(v-if='flixel.watermark' @click='deleteWatermark(flixel.watermark)') 
                button.btn.btn--red Delete Watermark
              
        .ui-input.ui-input--edit
          .ui-input--itemContent
            a(@click='closeEdit') 
              button.btn.btn--white Cancel
            a(@click='updateFlixelInvoke()')
              button.btn.btn--black Save Changes
</template>

<script>
import moment from 'moment';
import FlixelService from 'services/flixel.es6.js';
import UtilitiesService from 'services/utilities.es6.js';
import watermarkService from 'services/watermark.es6.js';
import singleFlixel from 'components/SingleFlixel.vue';
import SocialSharing from 'components/SocialSharing.vue';

export default {
  name: 'Flixel',
  metaInfo() {
    return {
      title: this.flixel.username + ' cinemagraph',
      meta: [
        {
          'property': 'image',
          'content': this.flixel.thumbnail,
        },
        {
          'property': 'description',
          'content': this.flixel.caption,
        },
        {
          'property': 'link',
          'content': this.flixel.link,
        },
        {
          'property': 'flixel',
          'content': {
            'id': this.flixel.id,
            'height': this.flixel.height,
            'width': this.flixel.width,
            'embed_url': this.flixel.embed_url,
            'video_url': this.flixel.tablet_mp4,
          },
        },
        {
          'property': 'twitter:player:height',
          'content': this.flixel.height,
        },
        {
          'property': 'twitter:player:width',
          'content': this.flixel.width,
        },
        {
          'property': 'twitter:player',
          'content': this.flixel.embed_url,
        },
        {
          'property': 'twitter:player',
          'content': this.flixel.embed_url,
        },
        {
          'property': 'twitter:app:url:iphone',
          'content': 'flixel://flixel/' + this.flixel.id,
        },
        {
          'property': 'twitter:app:url:ipad',
          'content': 'flixel://flixel/' + this.flixel.id,
        },
        {
          'name': 'medium',
          'content': 'video',
        },
        {
          'property': 'og:video',
          'content': this.flixel.video_url,
        },
        {
          'property': 'og:video:secure_url',
          'content': this.flixel.video_url,
        },
        {
          'property': 'og:video:type',
          'content': 'video/mp4',
        },
        {
          'property': 'og:video:width',
          'content': this.flixel.width,
        },
        {
          'property': 'og:video:height',
          'content': this.flixel.height,
        },
        {
          'name': 'twitter:card',
          'content': 'player',
        },
      ],
    };
  },
  data() {
    return {
      flixel: '',
      profile: '',
      EmbedTargetURLSelected: '',
      formattedCaption: '',
      isOwner: '',
      permission: {
        canChangeTargetLink: '',
        privacy: '',
      },
      showWarning: false,
      loading: false,
      editFlixel: {
        privacy: '',
        use_custom_target_link: '',
        embedable: '',
        shareable: '',
        target: '',
        caption: '',
      },
      modalShow: false,
      modalDelete: false,
      error: false,
      success: false,
    };
  },
  filters: {
    date: function (date) {
      return moment.utc(date).format('DD MMMM YYYY');
    },
  },
  created() {
    const self = this;
    self.account = JSON.parse(localStorage.getItem('account'));
    self.profile = JSON.parse(localStorage.getItem('profile'));
    this.getFlixel().then(function (data) {
      self.flixel = data.data;
      self.isOwner = self.flixel.username !== self.account.username ? false : true;
      if (self.isOwner) {
        self.permission.privacy = FlixelService.returnPrivacy(self.flixel.privacy);
        self.permission.canChangeTargetLink = self.flixel.canChangeTargetLink;
        self.permission.canCustomizeWatermark = self.flixel.canCustomizeWatermark;
        self.permission.canToggleWatermark = self.flixel.canToggleWatermark;
        self.showWarning = self.flixel.watermark && self.permission.canCustomizeWatermark;

        self.editFlixel.privacy = self.flixel.privacy;
        self.editFlixel.caption = self.flixel.caption;
        self.editFlixel.embedable = self.flixel.embedable;
        self.editFlixel.shareable = self.flixel.shareable;
        self.editFlixel.custom_target_link = self.flixel.custom_target_link;
        self.editFlixel.target = String(self.flixel.target_link);
        self.editFlixel.use_custom_target_link = self.flixel.use_custom_target_link;
        if (self.editFlixel.custom_target_link) {
          self.EmbedTargetURLSelected = true;
        } else {
          self.EmbedTargetURLSelected = false;
        }
      }
    });
  },
  methods: {
    showShareable(flixel) {
      const privacy = FlixelService.returnPrivacy(flixel);
      const shareable = this.flixel.shareable;

      if (privacy === 'private' || !shareable && !this.isOwner) {
        return false;
      }
      return true;
    },
    getFlixel() {
      return FlixelService.getOne(this.$route.params.hash)
        .then(function (data) {
          return data;
        }, function () {
          this.$route.push('404');
        });
    },
    showEditMenu() {
      window.scrollTo(0, 0);
      document.getElementById('flixelEdit').style.display = 'flex';
    },
    closeEdit() {
      document.getElementById('flixelEdit').style.display = 'none';
    },
    updateFlixelSuccess(data) {
      this.closeEdit();
      this.flixel = data.data;
      this.modalShow = true;
      this.modalDelete = false;
      this.success = true;
    },
    updateFlixelError(error) {
      this.closeEdit();
      this.modalShow = true;
      this.error = true;
      return error;
    },

    readyForm(flixel) {
      if (flixel.custom_target_link !== this.flixel.link) {
        flixel.use_custom_target_link = true;
        flixel.custom_target_link = UtilitiesService.prefixHttp(flixel.custom_target_link);
      }
      delete flixel.target;
      return UtilitiesService.createFormData(flixel);
    },

    updateFlixelInvoke() {
      const formData = this.readyForm(this.editFlixel);
      FlixelService.update(formData, this.flixel.hash)
        .then(this.updateFlixelSuccess, this.updateFlixelError);
    },
    deleteFlixelSuccess() {
      this.$router.push({ name: 'Profile', params: { username: this.account.username } });
    },

    deleteFlixelError() {
      this.modalShow = true;
      this.modalDelete = true;
    },

    deleteFlixelInvoke(hash) {
      FlixelService.delete(hash)
        .then(this.deleteFlixelSuccess, this.deleteFlixelError);
    },
    showDelete() {
      this.modalShow = true;
      this.modalDelete = true;
      this.success = false;
      this.error = false;
    },
    overlay() {
      this.modalError = false;
      this.error = false;
      this.success = false;
      this.modalShow = false;
    },
    deleteWatermark(id) {
      watermarkService.deleteWatermark(id)
        .then(this.deleteWatermarkSuccess, this.deleteWatermarkError);
    },
    deleteWatermarkSuccess() {
      this.closeEdit();
      this.flixel.watermark = '';
      this.modalShow = true;
      this.modalDelete = false;
      this.success = true;
      location.reload();
    },
    deleteWatermarkError() {
      this.closeEdit();
      this.modalShow = true;
      this.modalDelete = false;
      this.error = true;
    },
    useDefault() {
      this.editFlixel.use_custom_target_link = false;
      this.editFlixel.target = this.flixel.link;
      this.editFlixel.custom_target_link = this.flixel.link;
      this.editFlixel.useDefault = true;
    },
    noLink() {
      this.editFlixel.use_custom_target_link = true;
      this.editFlixel.useDefault = false;
      this.editFlixel.custom_target_link = '';
    },
  },
  components: {
    'singleFlixel': singleFlixel,
    'social-sharing': SocialSharing,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Flixel.vue